import { atom } from 'recoil';
import persistAtom from './recoilPersist';
export type LoginUserInfo = {
  username: string;
};
export const LoginUserInfoState = atom<LoginUserInfo>({
  key: 'LoginUserInfoState',
  default: {
    username: ''
  },
  effects_UNSTABLE: [persistAtom]
});